// toast.ts
type ToastFunc = (message: string) => void;

let globalShowToast: ToastFunc = (msg) => {
  console.warn('Toast 未初始化:', msg);
};

export const setToastHandler = (func: ToastFunc) => {
  globalShowToast = func;
};

export const showToast = (msg: string) => {
  globalShowToast(msg);
};